<template>
  <div class="mb-5">
    <router-link :to="{name: 'privacy-policy.list'}">See other policies</router-link>
    <div class="text-center">
      <h2>Livestream <br>(Alexa)</h2>
    </div>

    <hr />
    <div>
      <p>Effective Date: 05/10/2026</p>
    </div>
    <hr />

    <div>
      <h3>Introduction</h3>
      <p>This Privacy Policy describes how OpenMasjid.io ("we," "us," or "our") collects, uses, and discloses your information in connection with the OpenMasjid Alexa skill ("Skill"). The Skill is not directed to children under 13.</p>
    </div>
    <hr />

    <div>
      <h3>Information We Collect</h3>
      <p>We collect the following information through the Skill:</p>
      <ul>
        <li><strong>Amazon user id:</strong> Amazon sends an Amazon user id with each request from your Alexa device. We store that id. We do not receive your name, email address, or phone number from Alexa. We do not receive your voice recording. Amazon processes what you say to Alexa.</li>
        <li><strong>Linking code:</strong> Until your device is linked, the Skill speaks a 6-digit code. We store that code until you enter it in the OpenMasjid mobile app, or until it expires after 15 minutes.</li>
        <li><strong>OpenMasjid account:</strong> When you enter the code in the OpenMasjid mobile app while signed in, we link the Amazon user id to your OpenMasjid account. That account already holds the name and email address described in the <router-link :to="{name: 'privacy-policy.livestream-app'}">Livestream app privacy policy</router-link>.</li>
        <li><strong>Masjid preferences:</strong> We store the masjids you follow, which one is your home masjid, whether salah reminders are on, and which salah reminders you have muted, including whether you muted only the start or only the jamaat.</li>
      </ul>
    </div>
    <hr />

    <div>
      <h3>Use of Information</h3>
      <p>We use the information we collect for the following purposes:</p>
      <ul>
        <li><strong>Linking:</strong> We use the Amazon user id and the code to connect your Alexa device to your OpenMasjid account.</li>
        <li><strong>Live audio:</strong> We use your home masjid, or a masjid you name, to play that masjid's audio when it is on air. The audio is delayed by a few seconds. If the masjid is not on air, we do not play a stream.</li>
        <li><strong>Salah times:</strong> We use the masjid you ask about to tell you salah times.</li>
        <li><strong>Reminders:</strong> If you allow reminders, we create reminders in your Alexa account. Those reminders name the salah and, at jamaat, the home masjid. We use your mute settings to skip or remove reminders you do not want.</li>
        <li><strong>Live notification:</strong> When a masjid you follow goes on air, we ask Amazon to notify the linked Alexa user id. The notification includes the masjid name.</li>
      </ul>
    </div>
    <hr />

    <div>
      <h3>Information Sharing</h3>
      <p>We send reminder text and live-audio notifications to Amazon so Alexa can deliver them. We do not sell your information. The OpenMasjid mobile app sign-in is covered by the livestream app privacy policy. Amazon has its own privacy policy for Alexa.</p>
    </div>
    <hr />

    <div>
      <h3>Data Retention</h3>
      <p>We keep the Amazon user id, the link to your OpenMasjid account, and your masjid and reminder preferences for as long as the link exists. The 6-digit code is removed when you use it or when it expires. We also retain information as needed to comply with our legal obligations, resolve disputes, and enforce our agreements.</p>
    </div>
    <hr />

    <div>
      <h3>Your Choices</h3>
      <p>You can turn salah reminders on or off, and mute a salah or only its start or jamaat, by speaking to the Skill. You can ask us to delete the link between your Alexa device and your OpenMasjid account by contacting us at <a href="mailto:talha@arcticprism.com">talha@arcticprism.com</a>.</p>
    </div>
    <hr />

    <div>
      <h3>Security</h3>
      <p>We take reasonable steps to protect the information you provide from unauthorized access, disclosure, alteration, or destruction. However, no internet transmission or electronic storage is ever completely secure.</p>
    </div>
    <hr />

    <div>
      <h3>Changes to this Privacy Policy</h3>
      <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
    </div>
    <hr />

    <div>
      <h3>Contact Us</h3>
      <p>If you have any questions about this Privacy Policy, please contact us at:<br /> <a href="mailto:talha@arcticprism.com">talha@arcticprism.com</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LivestreamAlexaPrivacyPolicy"
}
</script>

<style scoped>

</style>
